import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, of } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import {
  createDeeplinkPathFromFlightSearchParams,
  mapOndMarketingOfferToFlightSearchParams,
} from '@fcom/common/utils/flight-search.utils';
import { LanguageService } from '@fcom/ui-translate';

import { OndMarketingOffersService } from '../services';
import { OndMarketingOffer, OndPairEnhancedResponse } from '../interfaces';

const INITIAL_OFFER_AMOUNT = 6;
const OFFERS_TO_LOAD_AMOUNT = 3;

@Component({
  selector: 'fin-ond-marketing-offers',
  templateUrl: './ond-marketing-offers.component.html',
  styleUrls: ['./ond-marketing-offers.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OndMarketingOffersComponent implements OnInit {
  private ondMarketingOffersService = inject(OndMarketingOffersService);
  private languageService = inject(LanguageService);
  private router = inject(Router);

  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  originLocationCode$: Observable<string | undefined> = of(undefined);
  @Input()
  destinationLocationCode$: Observable<string | undefined> = of(undefined);
  @Input()
  links$: Observable<OndPairEnhancedResponse>;

  moreOffersAmount: number = OFFERS_TO_LOAD_AMOUNT;
  offerAmount: number = INITIAL_OFFER_AMOUNT;

  ondOffers$: Observable<OndMarketingOffer[]>;
  heading$: Observable<string>;

  ngOnInit(): void {
    this.ondOffers$ = this.ondMarketingOffersService.getOffersOrFlightData(
      this.originLocationCode$,
      this.destinationLocationCode$,
      this.links$
    );

    this.heading$ = this.ondMarketingOffersService.getHeading(
      this.originLocationCode$,
      this.destinationLocationCode$,
      this.ondOffers$,
      'mostPopularDeals'
    );
  }

  loadMoreOffers(): void {
    this.offerAmount += this.moreOffersAmount;
  }

  navigateToUrl(ondOffer: OndMarketingOffer): void {
    const flightSearchParams = mapOndMarketingOfferToFlightSearchParams(ondOffer, this.languageService.langValue);
    if (flightSearchParams) {
      const deeplink = createDeeplinkPathFromFlightSearchParams(flightSearchParams);
      this.router.navigateByUrl(deeplink);
    }
  }
}
